import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  pageList: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  detail: { data: null, loading: false },
  exportedFiles: { data: [], loading: false },
  exportTaskInfo: { id: null, status: -1, progress: 0, viewUrl: '' },
  taskStatuses: { data: [], loading: false },
  dialog: { type: '', data: null, visible: false, loading: false },
  confirm: { title: '', content: '', name: '', visible: false, loading: false },
  searchParams: null,
  validError: false,
  fileList: [],
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
